import { Box, Button } from '@factorialco/deprecated-design-system'

export interface Props {
  result?: boolean
  onThumbsUp: () => Promise<void>
  onThumbsDown: () => Promise<void>
}

const FeedbackThumbs = ({ result, onThumbsUp, onThumbsDown }: Props) => {
  return (
    <Box flexDirection="row" gap="s8">
      <Button type={result ? 'positive' : 'secondary'} onClick={onThumbsUp} iconName="thumbs-up" />
      <Button
        type={result === false ? 'negative' : 'secondary'}
        onClick={onThumbsDown}
        iconName="thumbs-down"
      />
    </Box>
  )
}

export default FeedbackThumbs
